// @ts-nocheck
import { apiWithHeader, apiWithoutAuth } from "./api";
import { API_STATUS } from "./constant";
import { BACKEND_API_BASE_URL } from "../utilities/constant";
import { getUserAccessToken } from "../utilities/setting";
import { checkAuthSession } from "../views/dashboard/auth/auth-utils";

function safeMessagePart(value) {
  if (value === null || value === undefined) return '';
  const str = String(value).trim();
  const lower = str.toLowerCase();
  return lower === 'undefined' || lower === 'null' ? '' : str;
}

function getNetworkErrorMessage(error) {
  if (error?.code === "ECONNABORTED") {
    return "The request timed out. The server may be slow or unreachable — try again or restart the backend.";
  }
  if (error?.code === "ERR_NETWORK" || error?.message === "Network Error") {
    // Echo the actual target URL so a dev-time env override
    // (VITE_BACKEND_API_BASE_URL) doesn't get masked by the hard-coded
    // "port 3900 locally" hint.
    return `Cannot reach the API server at ${BACKEND_API_BASE_URL}. Confirm the backend is reachable and try again.`;
  }
  return "A network error occurred. This could be a CORS issue or a dropped internet connection.";
}

export const postApiCall = async (url, params, is_token_required = true, requestTimeout?) => {

  if (is_token_required) {
    const sessionValid = await checkAuthSession();
    if (!sessionValid) {
      return Promise.reject("Session Expired");
    }
  }  
    const token = getUserAccessToken();
  
    const response = await apiWithHeader(
      BACKEND_API_BASE_URL,
      'application/json',
      token,
      requestTimeout
    )
    .post(url, params)
    .catch(function (error) {
      if(error.response == undefined){
        var errorMsg = getNetworkErrorMessage(error);
      }else{
        // const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
        // const explanationMsg = error.response.data.message ? String(error.response.data.message) : String(error.response.data.error.explanation);
        // var errorMsg = `${dataMsg} ${explanationMsg}`

        const data = error?.response?.data;
        const dataMsg = safeMessagePart(data?.message);
        const explanationRaw = data?.error?.explanation ?? data?.error;
        let explanationMsg = '';
        if (Array.isArray(explanationRaw)) {
          explanationMsg = explanationRaw
            .map((item) => (typeof item === 'string' ? item : item?.message || ''))
            .filter(Boolean)
            .join('. ');
        } else {
          explanationMsg = safeMessagePart(explanationRaw);
          if (explanationMsg === '[object Object]') explanationMsg = '';
        }
        var errorMsg = '';
        if (explanationMsg && dataMsg && explanationMsg !== dataMsg) {
          errorMsg = /validation failed|something went wrong/i.test(dataMsg)
            ? explanationMsg
            : `${dataMsg} ${explanationMsg}`;
        } else {
          errorMsg = explanationMsg || dataMsg || 'Something went wrong';
        }
      }
      return Promise.reject(errorMsg);
    });
  
    if (response.status == API_STATUS.SUCCESS || response.status == API_STATUS.ACCEPED || response.status == API_STATUS.CREATED) {
        return response.data.data;
    } else {
        return Promise.reject(response.data);
    }

};

export const postApiNoAuthCall = async(url,params)=>{
  const response = await apiWithoutAuth(BACKEND_API_BASE_URL,'application/json').post(url,params).catch(function (error) {
      if(error.response == undefined){
        var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
      }else{
        const dataMsg = error?.response?.data?.message ? String(error?.response?.data?.message) : '';
        const explanationMsg = error?.response?.data?.message ? String(error?.response?.data?.message) : String(error?.response?.data?.error?.explanation);
        var errorMsg = '';
        if (dataMsg && explanationMsg) {
          if (dataMsg === explanationMsg) {
            errorMsg = dataMsg;
          } else {
            errorMsg = `${dataMsg} ${explanationMsg}`;
          }
        } else {
          errorMsg = dataMsg || explanationMsg || 'Something went wrong';
        }
      }
      return Promise.reject(errorMsg);
    });

    if (response.status == API_STATUS.SUCCESS || response.status == API_STATUS.ACCEPED || response.status == API_STATUS.CREATED) {
        return response.data; // Return full response object instead of just response.data.data
    } else {
        return Promise.reject(response.data);
    }

}

export const postApiMediaCall = async (url, formData) => {
  await checkAuthSession();
  const token = getUserAccessToken();
  
  const response = await apiWithHeader(BACKEND_API_BASE_URL, 'multipart/form-data', token)
  .post(url, formData)
  .catch(function (error) {
      if(error.response == undefined){
          var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
      }else{
          // const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
          // const explanationMsg = error.response.data?.error?.explanation ? String(error.response.data.error.explanation) : error.response.data.message;
          // var errorMsg = `${dataMsg} ${explanationMsg}`

        const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
        const explanationMsg = error.response.data.message ? String(error.response.data.message) : String(error.response.data.error.explanation);
        var errorMsg = '';
        if (dataMsg && explanationMsg) {
          if (dataMsg === explanationMsg) {
            errorMsg = dataMsg;
          } else {
            errorMsg = `${dataMsg} ${explanationMsg}`;
          }
        } else {
          errorMsg = dataMsg || explanationMsg || 'Something went wrong';
        }
      }
      return Promise.reject(errorMsg);
  });

  if (response.status === API_STATUS.SUCCESS || response.status === API_STATUS.ACCEPED || response.status === API_STATUS.CREATED) {
      return response.data.data;
  } else {
      return Promise.reject(response.data);
  }
};
